// @ts-check

export const cConnectivityPrivacyPath = 'settings.privacy.isConnectivityPrivate';

/** @enum {import('@/types/settings').cUserConnectivityIndicatorBehaviour} */
export const cUserConnectivityIndicatorBehaviour = /**
	* @type {typeof import('@/types/settings').cUserConnectivityIndicatorBehaviour}
	*/({
		trafficLight: 'trafficLight',
		onlineOnly: 'onlineOnly'
	});

/** @enum {import('@/types/settings').cSettingId} */
export const cSettingId = /**
	* @type {typeof import('@/types/settings').cSettingId}
	*/({
		userListManagementColumns: 'userListManagementColumns',
		exportsUserTable: 'exportsUserTable',
		users: 'users',
		structureOrders: 'structure.orders',
		structureDefaults: 'structure.defaults',
		serviceNameVariations: 'serviceNameVariations',
		keyAliases: 'keyAliases',
		themeMode: 'themeMode',
		videoChat: 'videoChat',
		searchRules: 'searchRules',
		videoChatSearch: 'video-chat-search',
		mentionSearch: 'mention-search',
		chatSearch: 'chat-search',
		userConnectivity: 'userConnectivity'
	});

export const cSettingsTabs = /** @type {const} */ ({
	branding: 'branding',
	date: 'date',
	myAccount: 'myAccount',
	footerSettings: 'footerSettings',
	dataMappingSettings: 'dataMappingSettings',
	searchSettings: 'searchSettings',
	socialSignIn: 'socialSignIn',
	notifications: 'notifications',
	integrations: 'integrations',
	defaults: 'defaults',
	appSettings: 'appSettings',
	userConnectivity: 'userConnectivity',
	languages: 'languages',
	videoChat: 'videoChat',
	advanced: 'advanced'
});

export const cSettingsCommunityBrandingTabs = /** @type {const} */ ({
	brandSettings: 'brandSettings',
	globalCss: 'globalCss',
	manageBrands: 'manageBrands',
	auditLogs: 'auditLogs'
});

/** route: { query: { "brandingTab": ... }} */
export const cSettingsBrandsQueryKey = 'brandingTab';
